import { z } from 'zod';

const PASSWORD_RULES = [
  {
    test: (val: string) => val.length >= 8,
    message: 'Password must be at least 8 characters',
  },
  {
    test: (val: string) => /[A-Z]/.test(val),
    message: 'Password must contain at least one uppercase letter',
  },
  {
    test: (val: string) => /[a-z]/.test(val),
    message: 'Password must contain at least one lowercase letter',
  },
  {
    test: (val: string) => /[0-9]/.test(val),
    message: 'Password must contain at least one number',
  },
];

export const passwordSchema = z
  .string()
  .trim()
  .min(1, 'Password is required')
  .superRefine((val, ctx) => {
    for (const rule of PASSWORD_RULES) {
      if (!rule.test(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: rule.message,
        });
      }
    }
  });

export const emailSchema = z
  .string()
  .email('Invalid email address')
  .transform((email) => email.toLowerCase().trim());

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export const signupSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: emailSchema,
  password: passwordSchema,
});

export const resetPasswordSchema = z
  .object({
    newPassword: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export const forgotPasswordSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
});
